import React from 'react'
import ContactBook from '../../components/ContactBook'

const ContactbookScreen = () => {
  return (
    <ContactBook />
  )
}

export default ContactbookScreen